// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","logo":"logo__jPF5-","localization_container":"localization_container__89rWt","localization_item":"localization_item__gp22M","active":"active__r+Z6z"};